import tinymce from 'tinymce';
import 'tinymce/themes/modern/theme';
import 'tinymce/plugins/link';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/table';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/code';
import 'tinymce/plugins/lists';

export default class Tinymce {
	constructor() {
		this.initialize();
	}

	initializeTinymce() {
		tinymce.init({
			selector: '.editor',
			branding: false,
			themes: 'modern',
			skin_url: '/assets/dist/css/tinymce/skins/lightgray',
			// language_url: '/assets/dist/i18n/tinymce/de.js',
			language_url: this._setLanguage(),
			height: 500,
			menubar: true,
			plugins: [
				'link autolink table fullscreen paste searchreplace code lists'
			],
			toolbar1: 'formatselect | bold italic underline | link unlink | alignleft aligncenter alignright | numlist bullist | removeformat | code',
			valid_children: '+p[class|style]'
		});
	}

	_setLanguage() {
		const path = '/assets/dist/i18n/tinymce/';

		const languageAttr = $('html').attr('lang');

		let languageUrl;

		if (languageAttr == 'de') {
			languageUrl = path + 'de.js';
		}

		return languageUrl
	}

	initialize() {
		this.initializeTinymce();
	}
}




// WEBPACK FOOTER //
// ./resources/assets/js/tinymce/tinymce.js